import optimizely, { optimizelyFeatures } from 'api/optimizely';
import { OPTIMIZELY_ACTIONS } from './actions-const';

export default function setOptimizelyExperiments() {
  const experiments = {
    simplifiedMobileHeader: optimizely.getFeatureVariable(optimizelyFeatures.SIMPLIFIED_MOBILE_HEADER, 'variant'),
  };

  return { type: OPTIMIZELY_ACTIONS.SET_EXPERIMENTS, experiments };
}
